import React from 'react';
import './Overview.scss';

const Overview = () => {
	const strengths = [
		'Accessibility Champion (WCAG 2.0-2.2)',
		'React/Redux Architecture Leader',
		'CI/CD Pipeline Implementation',
		'Team Mentorship & Training',
		'Performance Optimization',
		'UX/UI Design Systems',
	];

	const technologies = {
		frontend: ['CSS/SCSS/LESS', 'GraphQL', 'JavaScript', 'Next.js', 'React.js', 'TypeScript'],
		backend: ['Node.js', 'Python', 'PHP', 'Ruby'],
		devops: ['AWS S3', 'CI/CD', 'Docker', 'GIT', 'Jenkins', 'Kubernetes'],
		accessibility: ['Axe Core', 'IBM EAA', 'JAWS', 'NVDA', 'Pa11y', 'ReadSpeaker', 'WCAG'],
		testing: ['Cypress', 'Jest'],
	};

	return (
		<div className="overview">
			<h2 className="overview__title_header">Overview</h2>
			<div className="overview__section">
				<h3 className="overview__title">Key Strengths</h3>
				<ul className="overview__strengths">
					{strengths.map((strength, index) => (
						<li key={index} className="overview__strength">
							<span className="overview__check">✓</span>
							<span>{strength}</span>
						</li>
					))}
				</ul>
			</div>

			<div className="overview__section">
				<h3 className="overview__title">Core Technologies</h3>
				<div className="overview__technologies">
					{Object.entries(technologies).map(([category, techs]) => (
						<div key={category} className="overview__tech-category">
							<span className="overview__tech-label">
								{category.charAt(0).toUpperCase() + category.slice(1)}:
							</span>
							<span className="overview__tech-list">{techs.join(', ')}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Overview;
